<!-- Экран завершения пробного урока -->
<template>
    <div class="white_container tech_passed">
        <h2>🎉 {{$tc("lesson.LBL_PASSED_HEADER",level,{level:level})}}</h2>
        <p>{{$t("lesson.LBL_PASSED_DESCRIPTION")}}</p>
        <div class="button_wrapp">
            <button class="button" @click="toShop">
                <span>{{$t("lesson.LBL_PASSED_SHOP_BUTTON")}}</span>
            </button>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import store from '@/store';
    import i18n from '@/i18n';

    export default {
        name: "TechPassed",
        components: {

        },
        data: function () {
        return {
            loaded: false,
            isSoonLesson: -1,
            showTechCheckPassedFailPopup: false
        }
        },
        computed: {
            ...mapGetters({
                level: 'user/level',
            }),
        },
        mounted() {
            store.dispatch('user/updateProfile');
        },
        methods: {
            toShop(){
                this.$router.push({
                    name:"shop",
                    params:{
                        locale:i18n.locale,
                    }
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    .tech_passed{
        text-align: left;
        padding: 3rem 3.4rem 4rem;
        h2 {
        padding-bottom: 1rem;
        }
        .button_wrapp {
        display: flex;
        justify-content: center;
        width: 100%;
        }
        .button{
        text-align: center;
        padding: 0.75rem 2.5rem 1rem 2.5rem;
        margin-top: 3rem;
        margin-bottom: 6rem;

        }
        .start_container_text{
        margin-top: 2rem;
        }
    }
</style>